import { Sangha } from "@app/shared/types";
import { analyticsTrack } from "app/analytics/track";
import { ButtonWithLotus } from "components/ButtonWithLotus";
import * as React from "react";

export const SanghaStartButton = (props: {
    sangha: Sangha;
    disabled?: boolean;
    className?: string;
}) => {
    const { sangha, className, disabled } = props;
    const startLink = sangha.schedule.nextSession?.zoomInfo?.startLink;

    const sanghaSessionId = sangha.schedule.nextSession?.id;

    const onStartSession = (ev: React.MouseEvent<any>) => {
        ev.preventDefault();

        analyticsTrack("teacher.sangha.session.start", {
            session: sanghaSessionId,
            sanghaId: sangha.id,
            sanghaType: sangha.type,
        });

        window.open(startLink, "_blank");
    };

    return (
        <ButtonWithLotus
            variant="primary"
            className={className}
            onClick={onStartSession}
            href={startLink}
            disabled={disabled || !startLink}
            data-testid="startButton"
        >
            Start Session
        </ButtonWithLotus>
    );
};
